import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useDenominationSummary } from "../api";
import { useDenominationStore } from "../store";

export const DenominationSummaryTable = () => {
  const [searchParams] = useSearchParams();

  const selectedDenomination = useDenominationStore(
    state => state.selectedDenomination
  );

  const { data } = useDenominationSummary({
    denominationId: selectedDenomination?.id,
    startDate: searchParams.get("startDate"),
    endDate: searchParams.get("endDate")
  });

  // const structureTypeNames =
  //   data?.included_structure_types_in_report
  //     ?.map(type => type.name)
  //     .join(", ") || "";

  const parentStructureTypeName = data?.structure_type_hierarchy?.name || "";

  const summaryData = [
    {
      id: 1,
      title: `1. በ${parentStructureTypeName} ያሉ አጥቢያዎችን ብዛት`,
      items: [
        {
          name: `በ${parentStructureTypeName} ያሉ አጥቢያዎችን ብዛት`,
          male: "-",
          female: "-",
          total: data?.total_churches || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 2,
      title: `2. በ${parentStructureTypeName} ያሉ ሥርጭት ጣቢያዎች ብዛት`,
      items: [
        {
          name: `በአጥቢያዎች ሥር ያሉ የሥርጭት ጣቢያዎች ብዛት`,
          male: "-",
          female: "-",
          total: data?.new_church_plant?.branches_to_church || 0,
          reason: "-"
        },
        {
          name: `በ${parentStructureTypeName} ሥር ያሉ የሥርጭት ጣቢያዎች ብዛት`,
          male: "-",
          female: "-",
          total: data?.new_church_plant?.new_branches || 0,
          reason: "-"
        },
        {
          name: "በቀጣና ሥር ያሉ የሥርጭት ጣቢያዎች ብዛት",
          male: "-",
          female: "-",
          total: data?.new_church_plant?.total_branches || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male: "-",
          female: "-",
          total: data?.new_church_plant?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 3,
      title: `3. በ${parentStructureTypeName} ያሉ አባላት ብዛት`,
      items: [
        {
          name: `በ${parentStructureTypeName} ያሉ የተጠማቂ አባላት ብዛት`,
          male: data?.member_totals?.baptized?.male || "-",
          female: data?.member_totals?.baptized?.female || "-",
          total: data?.member_totals?.baptized?.total || 0,
          reason: "-"
        },
        {
          name: "ያልተጠመቁ ወገኖች ብዛት",
          male: data?.member_totals?.unbaptized?.male || "-",
          female: data?.member_totals?.unbaptized?.female || "-",
          total: data?.member_totals?.unbaptized?.total || 0,
          reason: "-"
        },
        {
          name: "የልጆች ብዛት",
          male: data?.member_totals?.children?.male || "-",
          female: data?.member_totals?.children?.female || "-",
          total: data?.member_totals?.children?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.member_totals?.baptized?.male +
              data?.member_totals?.unbaptized?.male +
              data?.member_totals?.children?.male || "-",
          female:
            data?.member_totals?.baptized?.female +
              data?.member_totals?.unbaptized?.female +
              data?.member_totals?.children?.female || "-",
          total:
            data?.member_totals?.baptized?.total +
              data?.member_totals?.unbaptized?.total +
              data?.member_totals?.children?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 4,
      title: `4. በልዩ ልዩ ምክንያቶች አሁን በ${parentStructureTypeName} የሌሉ አባላትን ብዛት`,
      items: [
        {
          name: "በሸኚ የለቀቁ ብዛት",
          male: data?.member_status_totals?.resigned?.male || "-",
          female: data?.member_status_totals?.resigned?.female || "-",
          total: data?.member_status_totals?.resigned?.total || 0,
          reason: "-"
        },
        {
          name: "ወደ ዓለም የተመለሱ ብዛት",
          male: data?.member_status_totals?.returned_to_world?.male || "-",
          female: data?.member_status_totals?.returned_to_world?.female || "-",
          total: data?.member_status_totals?.returned_to_world?.total || 0,
          reason: "-"
        },
        {
          name: "ከዚህ ዓለም በሞት የተለዩ ብዛት",
          male: data?.member_status_totals?.deceased?.male || "-",
          female: data?.member_status_totals?.deceased?.female || "-",
          total: data?.member_status_totals?.deceased?.total || 0,
          reason: "-"
        },
        {
          name: "ባልታወቀው ምክንያት የለቀቁ ብዛት",
          male: data?.member_status_totals?.unknown_reason?.male || "-",
          female: data?.member_status_totals?.unknown_reason?.female || "-",
          total: data?.member_status_totals?.unknown_reason?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.member_status_totals?.resigned?.male +
              data?.member_status_totals?.returned_to_world?.male +
              data?.member_status_totals?.deceased?.male +
              data?.member_status_totals?.unknown_reason?.male || "-",
          female:
            data?.member_status_totals?.resigned?.female +
              data?.member_status_totals?.returned_to_world?.female +
              data?.member_status_totals?.deceased?.female +
              data?.member_status_totals?.unknown_reason?.female || "-",
          total:
            data?.member_status_totals?.resigned?.total +
              data?.member_status_totals?.returned_to_world?.total +
              data?.member_status_totals?.deceased?.total +
              data?.member_status_totals?.unknown_reason?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 5,
      title: "5. ሪፖርቱ በሚሸፍንበት ጊዜ ከሌሎች ቤተ እምነቶች በሸኚ ወደ ቤ/ክ የመጡ አማኞች ብዛት",
      items: [
        {
          name: "ከሌሎች ቤተ አምነቶች ወደ ቤ/ክ የመጡ አማኞች ብዛት",
          male: data?.migrated_believers?.male || "-",
          female: data?.migrated_believers?.female || "-",
          total: data?.migrated_believers?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 6,
      title: "6. በበጀት አመቱ የዳኑና የውሃ ጥምቀት በመውሰድ ወደ ቤ/ክ የተቀላቀሉ ብዛት",
      items: [
        {
          name: "ጌታን የተቀበሉ ብዛት",
          male: data?.new_members?.accepted?.male || "-",
          female: data?.new_members?.accepted?.female || "-",
          total: data?.new_members?.accepted?.total || 0,
          reason: "-"
        },
        {
          name: "የድነት ትምህርት ተምረው የውሃ ጥምቀት የወሰዱ ብዛት",
          male: data?.new_members?.baptized?.male || "-",
          female: data?.new_members?.baptized?.female || "-",
          total: data?.new_members?.baptized?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.new_members?.accepted?.male +
              data?.new_members?.baptized?.male || "-",
          female:
            data?.new_members?.accepted?.female +
              data?.new_members?.baptized?.female || "-",
          total:
            data?.new_members?.accepted?.total +
              data?.new_members?.baptized?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 7,
      title: "7. የሙሉ ጊዜ አገልጋዮች ብዛት",
      items: [
        {
          name: "የመጋቢያን ብዛት",
          male: data?.servant_totals?.pastors?.male || "-",
          female: data?.servant_totals?.pastors?.female || "-",
          total: data?.servant_totals?.pastors?.total || 0,
          reason: "-"
        },
        {
          name: "የወንጌላዊያን ብዛት",
          male: data?.servant_totals?.evangelists?.male || "-",
          female: data?.servant_totals?.evangelists?.female || "-",
          total: data?.servant_totals?.evangelists?.total || 0,
          reason: "-"
        },
        {
          name: "የመምህራን ብዛት",
          male: data?.servant_totals?.teachers?.male || "-",
          female: data?.servant_totals?.teachers?.female || "-",
          total: data?.servant_totals?.teachers?.total || 0,
          reason: "-"
        },
        {
          name: "ያልተሾሙ የወንጌል አገልጋዮች ብዛት",
          male: data?.servant_totals?.not_appointed?.male || "-",
          female: data?.servant_totals?.not_appointed?.female || "-",
          total: data?.servant_totals?.not_appointed?.total || 0,
          reason: "-"
        },
        {
          name: "ሚሲዮናያዊን ብዛት",
          male: data?.servant_totals?.missionaries?.male || "-",
          female: data?.servant_totals?.missionaries?.female || "-",
          total: data?.servant_totals?.missionaries?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.servant_totals?.pastors?.male +
              data?.servant_totals?.evangelists?.male +
              data?.servant_totals?.teachers?.male +
              data?.servant_totals?.not_appointed?.male +
              data?.servant_totals?.missionaries?.male || "-",
          female:
            data?.servant_totals?.pastors?.female +
              data?.servant_totals?.evangelists?.female +
              data?.servant_totals?.teachers?.female +
              data?.servant_totals?.not_appointed?.female +
              data?.servant_totals?.missionaries?.female || "-",
          total:
            data?.servant_totals?.pastors?.total +
              data?.servant_totals?.evangelists?.total +
              data?.servant_totals?.teachers?.total +
              data?.servant_totals?.not_appointed?.total +
              data?.servant_totals?.missionaries?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 8,
      title: "8. የመጀመሪያ ድግሪ ያላቸው የሙሉ ጊዜ የወንጌል አገልጋዮች ብዛት",
      items: [
        {
          name: "የመጋቢያን ብዛት",
          male: data?.servant_degrees?.pastors?.male || "-",
          female: data?.servant_degrees?.pastors?.female || "-",
          total: data?.servant_degrees?.pastors?.total || 0,
          reason: "-"
        },
        {
          name: "የወንጌላዊያን ብዛት",
          male: data?.servant_degrees?.evangelists?.male || "-",
          female: data?.servant_degrees?.evangelists?.female || "-",
          total: data?.servant_degrees?.evangelists?.total || 0,
          reason: "-"
        },
        {
          name: "የመምህራን ብዛት",
          male: data?.servant_degrees?.teachers?.male || "-",
          female: data?.servant_degrees?.teachers?.female || "-",
          total: data?.servant_degrees?.teachers?.total || 0,
          reason: "-"
        },
        {
          name: "ያልተሾሙ የወንጌል አገልጋዮች ብዛት",
          male: data?.servant_degrees?.not_appointed?.male || "-",
          female: data?.servant_degrees?.not_appointed?.female || "-",
          total: data?.servant_degrees?.not_appointed?.total || 0,
          reason: "-"
        },
        {
          name: "ሚሲዮናያዊን ብዛት",
          male: data?.servant_degrees?.missionaries?.male || "-",
          female: data?.servant_degrees?.missionaries?.female || "-",
          total: data?.servant_degrees?.missionaries?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.servant_degrees?.pastors?.male +
              data?.servant_degrees?.evangelists?.male +
              data?.servant_degrees?.teachers?.male +
              data?.servant_degrees?.not_appointed?.male +
              data?.servant_degrees?.missionaries?.male || "-",
          female:
            data?.servant_degrees?.pastors?.female +
              data?.servant_degrees?.evangelists?.female +
              data?.servant_degrees?.teachers?.female +
              data?.servant_degrees?.not_appointed?.female +
              data?.servant_degrees?.missionaries?.female || "-",
          total:
            data?.servant_degrees?.pastors?.total +
              data?.servant_degrees?.evangelists?.total +
              data?.servant_degrees?.teachers?.total +
              data?.servant_degrees?.not_appointed?.total +
              data?.servant_degrees?.missionaries?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 9,
      title: "9. የመጀመሪያ ድግሪ የሌላቸው የሙሉ ጊዜ የወንጌል አገልጋዮች ብዛት",
      items: [
        {
          name: "የመጋቢያን ብዛት",
          male: data?.servant_without_degrees?.pastors?.male || "-",
          female: data?.servant_without_degrees?.pastors?.female || "-",
          total: data?.servant_without_degrees?.pastors?.total || 0,
          reason: "-"
        },
        {
          name: "የወንጌላዊያን ብዛት",
          male: data?.servant_without_degrees?.evangelists?.male || "-",
          female: data?.servant_without_degrees?.evangelists?.female || "-",
          total: data?.servant_without_degrees?.evangelists?.total || 0,
          reason: "-"
        },
        {
          name: "የመምህራን ብዛት",
          male: data?.servant_without_degrees?.teachers?.male || "-",
          female: data?.servant_without_degrees?.teachers?.female || "-",
          total: data?.servant_without_degrees?.teachers?.total || 0,
          reason: "-"
        },
        {
          name: "ያልተሾሙ የወንጌል አገልጋዮች ብዛት",
          male: data?.servant_without_degrees?.not_appointed?.male || "-",
          female: data?.servant_without_degrees?.not_appointed?.female || "-",
          total: data?.servant_without_degrees?.not_appointed?.total || 0,
          reason: "-"
        },
        {
          name: "ሚሲዮናያዊን ብዛት",
          male: data?.servant_without_degrees?.missionaries?.male || "-",
          female: data?.servant_without_degrees?.missionaries?.female || "-",
          total: data?.servant_without_degrees?.missionaries?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.servant_without_degrees?.pastors?.male +
              data?.servant_without_degrees?.evangelists?.male +
              data?.servant_without_degrees?.teachers?.male +
              data?.servant_without_degrees?.not_appointed?.male +
              data?.servant_without_degrees?.missionaries?.male || "-",
          female:
            data?.servant_without_degrees?.pastors?.female +
              data?.servant_without_degrees?.evangelists?.female +
              data?.servant_without_degrees?.teachers?.female +
              data?.servant_without_degrees?.not_appointed?.female +
              data?.servant_without_degrees?.missionaries?.female || "-",
          total:
            data?.servant_without_degrees?.pastors?.total +
              data?.servant_without_degrees?.evangelists?.total +
              data?.servant_without_degrees?.teachers?.total +
              data?.servant_without_degrees?.not_appointed?.total +
              data?.servant_without_degrees?.missionaries?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 10,
      title: "10. ሁለተኛ ድግሪ ያላቸው የሙሉ ጊዜ የወንጌል አገልጋዮች ብዛት",
      items: [
        {
          name: "የመጋቢያን ብዛት",
          male: data?.servant_with_masters?.pastors?.male || "-",
          female: data?.servant_with_masters?.pastors?.female || "-",
          total: data?.servant_with_masters?.pastors?.total || 0,
          reason: "-"
        },
        {
          name: "የወንጌላዊያን ብዛት",
          male: data?.servant_with_masters?.evangelists?.male || "-",
          female: data?.servant_with_masters?.evangelists?.female || "-",
          total: data?.servant_with_masters?.evangelists?.total || 0,
          reason: "-"
        },
        {
          name: "የመምህራን ብዛት",
          male: data?.servant_with_masters?.teachers?.male || "-",
          female: data?.servant_with_masters?.teachers?.female || "-",
          total: data?.servant_with_masters?.teachers?.total || 0,
          reason: "-"
        },
        {
          name: "ያልተሾሙ የወንጌል አገልጋዮች ብዛት",
          male: data?.servant_with_masters?.not_appointed?.male || "-",
          female: data?.servant_with_masters?.not_appointed?.female || "-",
          total: data?.servant_with_masters?.not_appointed?.total || 0,
          reason: "-"
        },
        {
          name: "ሚሲዮናያዊን ብዛት",
          male: data?.servant_with_masters?.missionaries?.male || "-",
          female: data?.servant_with_masters?.missionaries?.female || "-",
          total: data?.servant_with_masters?.missionaries?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.servant_with_masters?.pastors?.male +
              data?.servant_with_masters?.evangelists?.male +
              data?.servant_with_masters?.teachers?.male +
              data?.servant_with_masters?.not_appointed?.male +
              data?.servant_with_masters?.missionaries?.male || "-",
          female:
            data?.servant_with_masters?.pastors?.female +
              data?.servant_with_masters?.evangelists?.female +
              data?.servant_with_masters?.teachers?.female +
              data?.servant_with_masters?.not_appointed?.female +
              data?.servant_with_masters?.missionaries?.female || "-",
          total:
            data?.servant_with_masters?.pastors?.total +
              data?.servant_with_masters?.evangelists?.total +
              data?.servant_with_masters?.teachers?.total +
              data?.servant_with_masters?.not_appointed?.total +
              data?.servant_with_masters?.missionaries?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 11,
      title: "11. የመጀመሪያ ድግሪ ተምረው ሁለተኛ ድግሪ ያልተማሩ የሙሉ ጊዜ አገልጋዮች ብዛት",
      items: [
        {
          name: "የመጋቢያን ብዛት",
          male: data?.servant_with_degree_but_no_masters?.pastors?.male || "-",
          female:
            data?.servant_with_degree_but_no_masters?.pastors?.female || "-",
          total: data?.servant_with_degree_but_no_masters?.pastors?.total || 0,
          reason: "-"
        },
        {
          name: "የወንጌላዊያን ብዛት",
          male:
            data?.servant_with_degree_but_no_masters?.evangelists?.male || "-",
          female:
            data?.servant_with_degree_but_no_masters?.evangelists?.female ||
            "-",
          total:
            data?.servant_with_degree_but_no_masters?.evangelists?.total || 0,
          reason: "-"
        },
        {
          name: "የመምህራን ብዛት",
          male: data?.servant_with_degree_but_no_masters?.teachers?.male || "-",
          female:
            data?.servant_with_degree_but_no_masters?.teachers?.female || "-",
          total: data?.servant_with_degree_but_no_masters?.teachers?.total || 0,
          reason: "-"
        },
        {
          name: "ያልተሾሙ የወንጌል አገልጋዮች ብዛት",
          male:
            data?.servant_with_degree_but_no_masters?.not_appointed?.male ||
            "-",
          female:
            data?.servant_with_degree_but_no_masters?.not_appointed?.female ||
            "-",
          total:
            data?.servant_with_degree_but_no_masters?.not_appointed?.total || 0,
          reason: "-"
        },
        {
          name: "ሚሲዮናያዊን ብዛት",
          male:
            data?.servant_with_degree_but_no_masters?.missionaries?.male || "-",
          female:
            data?.servant_with_degree_but_no_masters?.missionaries?.female ||
            "-",
          total:
            data?.servant_with_degree_but_no_masters?.missionaries?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.servant_with_degree_but_no_masters?.pastors?.male +
              data?.servant_with_degree_but_no_masters?.evangelists?.male +
              data?.servant_with_degree_but_no_masters?.teachers?.male +
              data?.servant_with_degree_but_no_masters?.not_appointed?.male +
              data?.servant_with_degree_but_no_masters?.missionaries?.male ||
            "-",
          female:
            data?.servant_with_degree_but_no_masters?.pastors?.female +
              data?.servant_with_degree_but_no_masters?.evangelists?.female +
              data?.servant_with_degree_but_no_masters?.teachers?.female +
              data?.servant_with_degree_but_no_masters?.not_appointed?.female +
              data?.servant_with_degree_but_no_masters?.missionaries?.female ||
            "-",
          total:
            data?.servant_with_degree_but_no_masters?.pastors?.total +
              data?.servant_with_degree_but_no_masters?.evangelists?.total +
              data?.servant_with_degree_but_no_masters?.teachers?.total +
              data?.servant_with_degree_but_no_masters?.not_appointed?.total +
              data?.servant_with_degree_but_no_masters?.missionaries?.total ||
            0,
          reason: "-"
        }
      ]
    },
    {
      id: 12,
      title: "12. የመጋቢነት አገልግሎት መጽሐፍ ያጠኑ አገልጋዮች ብዛት",
      items: [
        {
          name: "የመጋቢያን ብዛት",
          male: data?.training_counts?.pastors?.male || "-",
          female: data?.training_counts?.pastors?.female || "-",
          total: data?.training_counts?.pastors?.total || 0,
          reason: "-"
        },
        {
          name: "የወንጌላዊያን ብዛት",
          male: data?.training_counts?.evangelists?.male || "-",
          female: data?.training_counts?.evangelists?.female || "-",
          total: data?.training_counts?.evangelists?.total || 0,
          reason: "-"
        },
        {
          name: "የመምህራን ብዛት",
          male: data?.training_counts?.teachers?.male || "-",
          female: data?.training_counts?.teachers?.female || "-",
          total: data?.training_counts?.teachers?.total || 0,
          reason: "-"
        },
        {
          name: "ያልተሾሙ የወንጌል አገልጋዮች ብዛት",
          male: data?.training_counts?.not_appointed?.male || "-",
          female: data?.training_counts?.not_appointed?.female || "-",
          total: data?.training_counts?.not_appointed?.total || 0,
          reason: "-"
        },
        {
          name: "ሚሲዮናያዊን ብዛት",
          male: data?.training_counts?.missionaries?.male || "-",
          female: data?.training_counts?.missionaries?.female || "-",
          total: data?.training_counts?.missionaries?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.training_counts?.pastors?.male +
              data?.training_counts?.evangelists?.male +
              data?.training_counts?.teachers?.male +
              data?.training_counts?.not_appointed?.male +
              data?.training_counts?.missionaries?.male || "-",
          female:
            data?.training_counts?.pastors?.female +
              data?.training_counts?.evangelists?.female +
              data?.training_counts?.teachers?.female +
              data?.training_counts?.not_appointed?.female +
              data?.training_counts?.missionaries?.female || "-",
          total:
            data?.training_counts?.pastors?.total +
              data?.training_counts?.evangelists?.total +
              data?.training_counts?.teachers?.total +
              data?.training_counts?.not_appointed?.total +
              data?.training_counts?.missionaries?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 13,
      title: "13. በቤት ኅብረት አገልግሎት የታቀፉ አባላት ብዛት",
      items: [
        {
          name: "በቤት ኅብረት አገልግሎት የታቀፉ ብዛት",
          male: data?.small_group_participation?.in_fellowship?.male || "-",
          female: data?.small_group_participation?.in_fellowship?.female || "-",
          total: data?.small_group_participation?.in_fellowship?.total || 0,
          reason: "-"
        },
        {
          name: "በቤት ኅብረት አገልግሎት ያልታቀፉ ብዛት",
          male: data?.small_group_participation?.not_in_fellowship?.male || "-",
          female:
            data?.small_group_participation?.not_in_fellowship?.female || "-",
          total: data?.small_group_participation?.not_in_fellowship?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.small_group_participation?.in_fellowship?.male +
              data?.small_group_participation?.not_in_fellowship?.male || "-",
          female:
            data?.small_group_participation?.in_fellowship?.female +
              data?.small_group_participation?.not_in_fellowship?.female || "-",
          total:
            data?.small_group_participation?.in_fellowship?.total +
              data?.small_group_participation?.not_in_fellowship?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 14,
      title: `14. በ${parentStructureTypeName} የተሰጡ ልዩ ልዩ ስልጠናዎችን ብዛት`,
      items: [
        {
          name: "ከወንጌል ሥርጭት አኳያ",
          male: "-",
          female: "-",
          total: data?.training_programs?.leadership || 0,
          reason: "-"
        },
        {
          name: "ደቀ መዝሙር ከማፍራት አኳያ",
          male: "-",
          female: "-",
          total: data?.training_programs?.children || 0,
          reason: "-"
        },
        {
          name: "መሪዎች ከማዘጋጀትና ከማብቃት አኳያ",
          male: "-",
          female: "-",
          total: data?.training_programs?.young_leaders || 0,
          reason: "-"
        },
        {
          name: "ከሰላም ግንባታ አኳያ",
          male: "-",
          female: "-",
          total: data?.training_programs?.leadership_training || 0,
          reason: "-"
        },
        {
          name: "ከሁለንተናዊ አገልግሎት አኳያ",
          male: "-",
          female: "-",
          total: data?.training_programs?.successors || 0,
          reason: "-"
        },
        {
          name: "የሙሉ ጊዜ የወንጌል አገልጋዮችን ከማብቃት አኳያ",
          male: "-",
          female: "-",
          total: data?.training_programs?.children || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male: "-",
          female: "-",
          total:
            data?.training_programs?.children +
              data?.training_programs?.successors +
              data?.training_programs?.leadership +
              data?.training_programs?.children || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 15,
      title: "15. ቋሚና ጊዜያዊ ሠራተኞች ብዛት",
      items: [
        {
          name: "ቋሚ ሠራተኞች ብዛት",
          male: data?.employee_totals?.permanent?.male || "-",
          female: data?.employee_totals?.permanent?.female || "-",
          total: data?.employee_totals?.permanent?.total || 0,
          reason: "-"
        },
        {
          name: "ጊዜያዊ ሠራተኞች ብዛት",
          male: data?.employee_totals?.contract?.male || "-",
          female: data?.employee_totals?.contract?.female || "-",
          total: data?.employee_totals?.contract?.total || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male:
            data?.employee_totals?.permanent?.male +
              data?.employee_totals?.contract?.male || "-",
          female:
            data?.employee_totals?.permanent?.female +
              data?.employee_totals?.contract?.female || "-",
          total:
            data?.employee_totals?.permanent?.total +
              data?.employee_totals?.contract?.total || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 16,
      title: "16. ሪፖርቱ በሚሸፍንበት ጊዜ የተጨመሩ የአጥቢያና ሥርጭት ጣቢያዎች ብዛት",
      items: [
        {
          name: "የተጨመሩ አጥቢያዎች ብዛት",
          male: "-",
          female: "-",
          total: data?.new_branches?.new_branches || 0,
          reason: "-"
        },
        {
          name: "የተጨመሩ የሥርጭት ጣቢያዎች ብዛት",
          male: "-",
          female: "-",
          total: data?.new_branches?.new_branches || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male: "-",
          female: "-",
          total: data?.new_branches?.new_branches || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 17,
      title: "17. የቤተ ክርስቲያኒቷ አምልኮ ቦታዎች ብዛት",
      items: [
        {
          name: "በመንግስት ምሪት የተገኘ አምልኮ ቦታ ብዛት",
          male: "-",
          female: "-",
          total: data?.church_worship_center?.government_granted_places || 0,
          reason: "-"
        },
        {
          name: "በግዢ የተገኘ የአምልኮ ቦታ ብዛት",
          male: "-",
          female: "-",
          total: data?.church_worship_center?.purchase_places || 0,
          reason: "-"
        },
        {
          name: "በስጦታ የተገኘ የአምልኮ ቦታብዛት",
          male: "-",
          female: "-",
          total: data?.church_worship_center?.gifted_places || 0,
          reason: "-"
        },
        {
          name: "በሊዝ የተገኘ አምልኮ ቦታ ብዛት",
          male: "-",
          female: "-",
          total: data?.church_worship_center?.leased_places || 0,
          reason: "-"
        },
        {
          name: "በክራይ ያሉ የአምልኮ ቦታ ብዛት",
          male: "-",
          female: "-",
          total: data?.church_worship_center?.rented_places || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male: "-",
          female: "-",
          total:
            data?.church_worship_center?.government_granted_places +
              data?.church_worship_center?.purchase_places +
              data?.church_worship_center?.gifted_places +
              data?.church_worship_center?.leased_places +
              data?.church_worship_center?.rented_places || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 18,
      title: "18. የቤተ ክርሰቲያኒቷ ሀብትና ንብረት",
      items: [
        {
          name: "የማመለኪያ አዳራሽ ህንጻ ብዛት",
          male: "-",
          female: "-",
          total: data?.church_property?.church_building || 0,
          reason: "-"
        },
        {
          name: "የሁለገብ ህንጻ ብዛት",
          male: "-",
          female: "-",
          total: data?.church_property?.multi_purpose_buildings || 0,
          reason: "-"
        },
        {
          name: "የመኪና",
          male: "-",
          female: "-",
          total: data?.church_property?.vehicles || 0,
          reason: "-"
        },
        {
          name: "ሞተር ሳይክልና ባለ ሦስት እግር ተሽከርካሪ ብዛት",
          male: "-",
          female: "-",
          total: data?.church_property?.motorcycles_and_three_wheelers || 0,
          reason: "-"
        },
        {
          name: "ቋሚና ሌሎች",
          male: "-",
          female: "-",
          total: data?.church_property?.fixed_and_others || 0,
          reason: "-"
        },
        {
          name: "አጠቃላይ ድምር",
          male: "-",
          female: "-",
          total:
            data?.church_property?.church_building +
              data?.church_property?.multi_purpose_buildings +
              data?.church_property?.vehicles +
              data?.church_property?.motorcycles_and_three_wheelers +
              data?.church_property?.fixed_and_others || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 19,
      title: "19. መደበኛ ትምህርት ቤቶችን ብዛት",
      items: [
        {
          name: "መዋዕለ ሕጻናት ትምህርት ቤት ብዛት",
          male: "-",
          female: "-",
          total: data?.church_school?.kindergartens || 0,
          reason: "-"
        },
        {
          name: "1ኛ ደረጃ ትምህርት ቤት ብዛት",
          male: "-",
          female: "-",
          total: data?.church_school?.primary_schools || 0,
          reason: "-"
        },
        {
          name: "2ኛ ደረጃ ትምህርት ቤት ብዛት",
          male: "-",
          female: "-",
          total: data?.church_school?.secondary_schools || 0,
          reason: "-"
        },
        {
          name: "መጽሕፍ ቅዱስ ትምህርት ቤት ብዛት",
          male: "-",
          female: "-",
          total: data?.church_school?.bible_schools || 0,
          reason: "-"
        },
        {
          name: "የመጽሐፍ ቅዱስ ኮሌጅ ብዛት",
          male: "-",
          female: "-",
          total: data?.church_school?.bible_colleges || 0,
          reason: "-"
        }
      ]
    },
    {
      id: 20,
      title: "20. የእቅድ አፈጻጸምን በፐርሰንት",
      items: [
        {
          name: "በበጀት አመቱ የዳኑት",
          male: "-",
          female: "-",
          total: 0,
          reason: "-"
        },
        {
          name: "መሪዎች ማዘጋጀትና ማብቃት",
          male: "-",
          female: "-",
          total: 0,
          reason: "-"
        },
        {
          name: "ያመኑትን ደቀ መዝሙር ከማድረግ አኳያ",
          male: "-",
          female: "-",
          total: 0,
          reason: "-"
        },
        {
          name: "ከሰላም ግንባታ አንጻር",
          male: "-",
          female: "-",
          total: 0,
          reason: "-"
        },
        {
          name: "ከሁለንተናዊ አገልግሎት አንጻር",
          male: "-",
          female: "-",
          total: 0,
          reason: "-"
        },
        {
          name: "አባላት በቤት ኅብርት አገልግሎት ከመያዝ አኳያ",
          male: "-",
          female: "-",
          total: 0,
          reason: "-"
        }
      ]
    }
  ];

  return (
    <TableContainer sx={{ maxHeight: "100vh" }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                width: "70%",
                bgcolor: "#F9F9F9",
                color: "primary.main",
                fontWeight: "bold"
              }}
            >
              ጥያቄ
            </TableCell>
            <TableCell
              align="right"
              sx={{
                bgcolor: "#F9F9F9",
                color: "primary.main",
                fontWeight: "bold"
              }}
            >
              ወንድ
            </TableCell>
            <TableCell
              align="right"
              sx={{
                bgcolor: "#F9F9F9",
                color: "primary.main",
                fontWeight: "bold"
              }}
            >
              ሴት
            </TableCell>
            <TableCell
              align="right"
              sx={{
                bgcolor: "#F9F9F9",
                color: "primary.main",
                fontWeight: "bold"
              }}
            >
              ድምር
            </TableCell>
            <TableCell
              align="right"
              sx={{
                bgcolor: "#F9F9F9",
                color: "primary.main",
                fontWeight: "bold"
              }}
            >
              ማብራሪያ
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {summaryData.map(section => (
            <>
              <TableRow key={section.id}>
                <TableCell colSpan={5}>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {section.title}
                  </Typography>
                </TableCell>
              </TableRow>
              {section.items.map((item, index) => (
                <TableRow key={`${section.id}-${index}`}>
                  <TableCell sx={{ pl: 4 }}>{item.name}</TableCell>
                  <TableCell align="right">{item.male}</TableCell>
                  <TableCell align="right">{item.female}</TableCell>
                  <TableCell align="right">
                    {item.total.toLocaleString()}
                  </TableCell>
                  <TableCell align="right">{item.reason}</TableCell>
                </TableRow>
              ))}
            </>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
